window.modals = {};

window.modals.initaliseModals = function() {
  const modalpopups = document.getElementsByClassName("modal-popup");
  const modalscreenElement = document.getElementById("modal-screen");


  function setCookie(name,value,days) {
      var expires = "";
      if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }
  function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return null;
  }
  function eraseCookie(name) {   
      document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

  function hasClass(elem, className) {
      return new RegExp(' ' + className + ' ').test(' ' + elem.className + ' ');
  }

  function addClass(elem, className) {
      if (!hasClass(elem, className)) {
          elem.className += ' ' + className;
      }
  }

  function removeClass(elem, className) {
      var newClass = ' ' + elem.className.replace( /[\t\r\n]/g, ' ') + ' ';
      if (hasClass(elem, className)) {
          while (newClass.indexOf(' ' + className + ' ') >= 0 ) {
              newClass = newClass.replace(' ' + className + ' ', ' ');
          }
          elem.className = newClass.replace(/^\s+|\s+$/g, '');
      }
  } 

  window.modals.popups = [];
  window.modals.shown = [];

  window.modals.openNextModal = function() {
    //find the next modal
    let modal = undefined;
    for (let i = 0; i < window.modals.popups.length; i++) {
      if (window.modals.popups[i].id && window.modals.shown.indexOf(window.modals.popups[i].id)<0) {
        modal = window.modals.popups[i];
      }
    }
    if (modal){
      const {id, delay, frequency} = modal;
      
      const modalElement = document.getElementById(id);
      window.modals.shown.push(id);
      setTimeout(() => {
        //add classes to show screen and modal
        addClass(modalElement, 'active')
        addClass(modalscreenElement, 'active')

        window.document.dispatchEvent(
          new CustomEvent('openPopup', { detail: {id: id} })
        );

        if (frequency !== 0) {
          setCookie(id,true,frequency);
        }

      }, delay);
    }
  }

  window.modals.closeActiveModal = function() {
    //remove all active classes
    removeClass(modalscreenElement, 'active')
    for (let i = 0; i < window.modals.popups.length; i++) {
      removeClass(document.getElementById(window.modals.popups[i].id), 'active');
    }
    //open the next modal
    window.modals.openNextModal();
  }

  //for each rendered popup
  for (let i = 0; i < modalpopups.length; i++) {
    const id = modalpopups[i].id;
    //number of seconds to wait before opening popup
    var delay = parseInt(modalpopups[i].dataset.delay);
    if (!delay) {
      delay = 0;
    }
    //how often (in days) to display popup, 0 = on every page load
    const frequency = parseInt(modalpopups[i].dataset.frequency);
    
    //if cookie checks out ok
    if (frequency === 0 || !getCookie(id)){ 
      window.modals.popups.push({
        id,
        delay,
        frequency
      })
    }
  }

  window.modals.openNextModal();
}

document.addEventListener("DOMContentLoaded", function() {
  window.modals.initaliseModals();
});
